import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { FaPlus, FaSpinner } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { UAParser } from 'ua-parser-js';
import { Table } from 'reactstrap';
import { format, isAfter } from 'date-fns';

import useCountdown from '../../utils/hooks/useCountDown';

const DevicesLimit = ({ devices, deleteDevice, redirectToCancel, return_url, expiration, limit, actual }) => {
  const { minutes, seconds } = useCountdown(expiration);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [loading, setLoading] = useState(false);

  if (isAfter(new Date(), Date.parse(expiration))) {
    redirectToCancel();
  }
  useEffect(() => {
    if (devices.length > 0 && minutes == 0 && seconds == 0) {
      redirectToCancel();
    }
  }, [minutes, seconds]);

  useEffect(() => {
    if (selectedDevices.length >= actual - (limit - 1)) {
      setLoading(true);
      deleteDevice({
        deviceToken: selectedDevices.map((device) => device.token).join('|'),
        return_url,
        cp: selectedDevices[0].customer.idp.code,
        customerId: selectedDevices[0].customer.id,
      });
    }
  }, [selectedDevices]);

  return (
    <div className="devices">
      <div className="header">
        <h1>
          <FormattedMessage id="Devices.limit.title" values={{ total: limit }} />
        </h1>
        <h2>
          <FormattedMessage
            id="Devices.limit.subTitle"
            values={{
              minutes,
              seconds,
              quantity: actual - (limit - 1) - selectedDevices.length >= 0 ? actual - (limit - 1) - selectedDevices.length : 0,
            }}
          />
        </h2>
      </div>
      <div className="devices-table">
        <Table flex responsive>
          <thead>
            <tr>
              <th>
                <FormattedMessage id="Devices.limit.devices" />
              </th>
              <th>
                <FormattedMessage id="Devices.limit.startDate" />
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {devices &&
              devices.map((device) => {
                const uat = new UAParser(device.description);
                const description = uat.getBrowser().name ? `${uat.getBrowser().name} ${uat.getBrowser().version}` : uat.getUA();
                return (
                  <tr key={device.token}>
                    <td>{description}</td>
                    <td>{format(new Date(device.createdAt), 'yyyy.MM.dd HH:mm')}</td>
                    <td>
                      {!selectedDevices.map((device) => device.token).includes(device.token) ? (
                        <FaPlus
                          style={{
                            color: '#202020ff',
                            backgroundColor: '#ffffffc5',
                            borderRadius: '50%',
                            width: '18px',
                            height: '18px',
                            padding: '2px'
                          }}
                          onClick={() => !loading && setSelectedDevices([...selectedDevices, device])}
                        />
                      ) : loading && (
                        <div className="loading-icon">
                          <FaSpinner />
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
      <div className="delete-all">
        <div className="actions">
          <button onClick={() => setSelectedDevices(devices)}>
            <FormattedMessage id="Devices.limit.all" />
          </button>
        </div>
      </div>
    </div>
  );
};

DevicesLimit.propTypes = {
  devices: PropTypes.array.isRequired,
  deleteDevice: PropTypes.func.isRequired,
  redirectToCancel: PropTypes.func.isRequired,
  deleteAllDevices: PropTypes.func.isRequired,
  limit: PropTypes.number.isRequired,
  actual: PropTypes.number.isRequired,
  return_url: PropTypes.string.isRequired,
  expiration: PropTypes.string.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func,
  }).isRequired,
  intl: PropTypes.object,
};

export default DevicesLimit;
